<template>
  <div>
    <FormHeading :h="4">
      <AppIcon icon="mdi:camera-outline" size="large" start />
      {{ $tt('image_upload') }}: {{ name }}
    </FormHeading>
    <AppRow sequence-two unwrapped>
      <AppCol v-for="({ label, hint, url, type }) in neededImageUploads">
        <ImageInput :url :label :hint :loading @change="$emit('change', type, $event)" />
      </AppCol>
    </AppRow>
  </div>
</template>

<script setup lang="ts">
import type { ApplicantFiles, ApplicantPhotoType, Product } from '~/types';

interface ImageUpload {
  type: ApplicantPhotoType;
  url: string | undefined;
  label: string;
  hint: string;
}

const props = defineProps<{
  name: string;
  types: Product['photo_types'];
  images: ApplicantFiles;
  loading: boolean;
}>();

defineEmits<{
  change: [type: ApplicantPhotoType, file: File | null];
}>();

const { tt } = useLocalization();
const imageUploads = computed<ImageUpload[]>(() => [
  {
    type: 'face',
    url: props.images.face,
    label: tt('applicant_photos.face'),
    hint: tt('applicant_photos.face_upload_hint')
  }, {
    type: 'passport',
    url: props.images.passport,
    label: tt('applicant_photos.passport'),
    hint: tt('applicant_photos.passport_upload_hint')
  }, {
    type: 'card',
    url: props.images.card,
    label: tt('applicant_photos.card'),
    hint: tt('applicant_photos.card_upload_hint')
  }, {
    type: 'invitation',
    url: props.images.invitation,
    label: tt('applicant_photos.invitation'),
    hint: tt('applicant_photos.invitation_upload_hint')
  }, {
    type: 'return_ticket',
    url: props.images.return_ticket,
    label: tt('applicant_photos.return_ticket'),
    hint: tt('applicant_photos.return_ticket_upload_hint')
  }, {
    type: 'booking',
    url: props.images.booking,
    label: tt('applicant_photos.booking'),
    hint: tt('applicant_photos.booking_upload_hint')
  }, {
    type: 'bank',
    url: props.images.bank,
    label: tt('applicant_photos.bank'),
    hint: tt('applicant_photos.bank_upload_hint')
  }, {
    type: 'address_proof',
    url: props.images.address_proof,
    label: tt('applicant_photos.address_proof'),
    hint: tt('applicant_photos.address_proof_upload_hint')
  }, {
    type: 'occupation',
    url: props.images.occupation,
    label: tt('applicant_photos.occupation'),
    hint: tt('applicant_photos.occupation_upload_hint')
  }, {
    type: 'travel_ticket',
    url: props.images.travel_ticket,
    label: tt('applicant_photos.travel_ticket'),
    hint: tt('applicant_photos.travel_ticket_upload_hint')
  }
]);
const neededImageUploads = computed(() => imageUploads.value.filter(({ type }) => props.types!.includes(type)));
</script>